<template>
  <div>
    <!-- 触发按钮 -->
    <el-button type="primary" @click="specialSubjectVisible = true"> 编辑 </el-button>

    <!-- 弹窗主体 -->
    <el-dialog
      title="专题设置"
      :visible.sync="specialSubjectVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <!-- 专题列表 -->
      <div class="topic-list">
        <el-card
          v-for="(topic, index) in specialSubjectForm"
          :key="index"
          class="topic-item"
        >
          <div class="topic-header">
            <span>专题{{ index + 1 }}</span>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleDelete(index)"
            ></el-button>
          </div>

          <!-- 专题表单 -->
          <el-form
            :model="topic"
            :rules="rules"
            :ref="'topicForm' + index"
            label-width="100px"
          >
            <el-form-item label="专题名称" prop="sub_title">
              <el-input
                v-model="topic.sub_title"
                placeholder="请输入专题名称"
                size="small"
                maxlength="10"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="专题入口图"
              prop="image"
              class="avatar-uploader"
            >
              <UploadImg
                :index="index"
                :f_thumb="specialSubjectForm.image"
                :f_thumb_str="specialSubjectForm.image_str"
                @emitImg="emitImg"
              ></UploadImg>
              <div class="prompt">建议上传538*240</div>
            </el-form-item>

            <el-form-item
              label="专题头图"
              prop="head_image"
              class="avatar-uploader"
            >
              <UploadImg
                :index="index"
                :f_thumb="specialSubjectForm.head_image"
                :f_thumb_str="specialSubjectForm.head_image_str"
                @emitImg="emitHeadImg"
              ></UploadImg>
              <div class="prompt">建议上传538*240</div>
            </el-form-item>
          </el-form>
        </el-card>
      </div>

      <!-- 添加按钮 -->
      <div class="add-action">
        <el-button
          type="text"
          icon="el-icon-plus"
          :disabled="specialSubjectForm.length >= 4"
          @click="handleAdd"
        >
          添加专题
          <span v-if="specialSubjectForm.length >= 4" class="limit-tip"
            >（已达上限）</span
          >
        </el-button>
      </div>

      <!-- 弹窗操作栏 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import UploadImg from "@/components/uploadImg/index";
export default {
  components: {
    UploadImg,
  },
  data() {
    return {
      specialSubjectVisible: false,
      submitting: false,
      originalspecialSubjectForm: [], // 保存原始数据用于取消恢复
      specialSubjectForm: [
        {
          sub_title: "",
          image: "",
          image_str: "",
          head_image: "",
          head_image_str: "",
        },
      ],
      rules: {
        sub_title: [
          { required: true, message: "请输入专题名称", trigger: "blur" },
        ],
        head_image: [
          { required: true, message: "请上传头图", trigger: "blur" },
        ],
        image: [{ required: true, message: "请上传入口图", trigger: "change" }],
      },
    };
  },
  watch: {
    specialSubjectVisible(val) {
      if (val) {
        // 打开弹窗时备份原始数据
        this.originalspecialSubjectForm = JSON.parse(
          JSON.stringify(this.specialSubjectForm)
        );
      }
    },
  },
  methods: {
    // 添加专题
    handleAdd() {
      if (this.specialSubjectForm.length >= 4) return;
      this.specialSubjectForm.push({
        name: "",
        title: "",
        image: "",
      });
    },

    // 删除专题
    handleDelete(index) {
      this.$confirm("确定删除该专题吗？", "提示", {}).then(() => {
        this.specialSubjectForm.splice(index, 1);
      });
    },
    // 专题入口图
    emitImg(data, index) {
      this.specialSubjectForm[index].image = data.pic;
      this.specialSubjectForm[index].image_str = data.path;
    },
    // 专题头图
    emitHeadImg(data, index) {
      this.specialSubjectForm[index].head_image = data.pic;
      this.specialSubjectForm[index].head_image_str = data.path;
    },

    // 提交保存
    handleSubmit() {
      // 验证所有表单
      const validateResults = this.specialSubjectForm.map((_, index) => {
        return new Promise((resolve) => {
          this.$refs[`topicForm${index}`][0].validate((valid) => {
            resolve(valid);
          });
        });
      });

      Promise.all(validateResults).then((results) => {
        if (results.every((valid) => valid)) {
          this.submitting = true;

          // 此处调用保存API
          setTimeout(() => {
            this.$message.success("保存成功");
            this.specialSubjectVisible = false;
            this.submitting = false;
          }, 1000);
        } else {
          this.$message.warning("请完善专题信息");
        }
      });
    },

    // 取消操作
    handleCancel() {
      if (
        JSON.stringify(this.specialSubjectForm) !==
        JSON.stringify(this.originalspecialSubjectForm)
      ) {
        this.$confirm("尚未保存修改，确定要取消吗？", "提示", {}).then(() => {
          this.specialSubjectForm = JSON.parse(
            JSON.stringify(this.originalspecialSubjectForm)
          );
          this.specialSubjectVisible = false;
        });
      } else {
        this.specialSubjectVisible = false;
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.topic-list {
  //   max-height: 60vh;
  //   overflow-y: auto;
  //   padding-right: 10px;

  .topic-item {
    margin-bottom: 15px;

    .topic-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      padding-bottom: 8px;
      border-bottom: 1px solid #eee;
    }
  }
}

.add-action {
  text-align: center;
  margin: 15px 0;

  .limit-tip {
    color: #f56c6c;
    margin-left: 5px;
  }
}

.avatar-uploader {
  ::v-deep .el-form-item__content {
    height: 120px;
  }

  .prompt {
    font-size: 12px;
    text-align: left;
    color: red;
    padding-left: 10px;
  }
}
</style>